import { useCallback } from 'react';

import Button, { ButtonAppearance, ButtonIconPosition, ButtonKind } from 'bloko/blocks/button';
import { FormSpacer } from 'bloko/blocks/form';
import Icon, { IconScale, IconView } from 'bloko/blocks/icon';
import Select, { Option } from 'bloko/blocks/select';

import useTrls from 'hooks/translation/useTrls';

import InputWithMultiDatePicker from 'components/InputWithMultiDatePicker';

import setDefaultFilter from 'components/Admin/Invoices/Filter/actions/setDefaultFilter';
import updateFilterType from 'components/Admin/Invoices/Filter/actions/updateFilterType';
import fetchInvoices from 'components/Admin/Invoices/Filter/fetchInvoices';
import FilterValue from 'components/Admin/Invoices/Filter/FilterValue';
import saveCSV from 'components/Admin/Invoices/Filter/saveCSV';

import { InvoiceFilterType, setDates } from 'store/models/invoices';
import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/Invoices/Filter/Filter.less';

const FILTER_ITEMS = [
    InvoiceFilterType.EmployerId,
    InvoiceFilterType.InvoiceName,
    InvoiceFilterType.Any,
    InvoiceFilterType.InvoiceId,
    InvoiceFilterType.UserId,
    InvoiceFilterType.PayerId,
    InvoiceFilterType.AccountId,
    InvoiceFilterType.ContractId,
    InvoiceFilterType.Manual,
    InvoiceFilterType.Status,
];

const Filter = () => {
    const { filterType, filterValue, from, to, invoices, accounts } = useSelector((state) => state.invoices);
    const dispatch = useDispatch();

    const trl = useTrls();

    const onClick = useCallback(() => {
        dispatch(fetchInvoices(from, to, filterType, filterValue));
    }, [dispatch, filterType, filterValue, from, to]);
    const setDatesForMultiDatePicker = useCallback(
        (from, to) => {
            dispatch(setDates({ from, to }));
        },
        [dispatch]
    );

    return (
        <div className="invoices-filter">
            <div className="invoices-filter__type">
                <Select
                    value={filterType}
                    onChange={(event) => {
                        dispatch(updateFilterType(event.target.value));
                    }}
                    data-qa="select-search-by"
                >
                    {FILTER_ITEMS.map((itemType) => (
                        <Option key={itemType} value={itemType}>
                            {trl(`admin.Invoices.Filter.${itemType}`)}
                        </Option>
                    ))}
                </Select>
            </div>
            <FormSpacer>
                <FilterValue onClick={onClick} />
            </FormSpacer>
            <FormSpacer>
                <InputWithMultiDatePicker from={from} to={to} action={setDatesForMultiDatePicker} />
            </FormSpacer>
            <div className="invoices-filter__actions">
                <FormSpacer>
                    <Button
                        appearance={ButtonAppearance.Outlined}
                        onClick={() => saveCSV(from, to, filterType, filterValue, invoices, accounts, trl)}
                        icon={<Icon view={IconView.ArrowLine} scale={IconScale.Small} />}
                        iconPosition={ButtonIconPosition.Left}
                    >
                        {trl('admin.actions.csv')}
                    </Button>
                </FormSpacer>
                <FormSpacer>
                    <Button
                        appearance={ButtonAppearance.Outlined}
                        onClick={() => {
                            dispatch(setDefaultFilter());
                        }}
                    >
                        {trl('admin.Invoices.Filter.clear')}
                    </Button>
                </FormSpacer>
                <FormSpacer>
                    <Button kind={ButtonKind.Primary} onClick={onClick} data-qa="search-button">
                        {trl('admin.Invoices.Filter.find')}
                    </Button>
                </FormSpacer>
            </div>
        </div>
    );
};

export default Filter;
